import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store/index';
import axios from 'axios';
import util from './util/search';
import statusDesc from './util/statusDesc';
import taskStatusDesc from './util/taskStatusDesc';
import * as date from './util/date.js';
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import websocket from './js/websocket.js'

import './js/utils';
import jsoneditor from 'jsoneditor';
import Snotify from 'vue-snotify';
import 'vue-snotify/styles/material.css'; // 引入样式


import './index.css'//引入全局样式


Vue.use(Snotify);
axios.defaults.timeout = 3 * 60 * 1000;
Vue.prototype.websocket = websocket;
// import IPconfig from './util/IPconfig';
// axios.defaults.headers.withCredentials = true;
// axios.defaults.withCredentials = true
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 增加请求信息
axios.interceptors.request.use(
  config => {
    // sessionStorage.getItem('token')
    let token = localStorage.getItem('token');

    if (!token || token == 'undefined') {
      token = ''
    }
    config.headers.Authorization = 'Bearer ' + token;
    return config
  },
  error => {
    return Promise.reject(error)
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // 对响应错误做处理
    if (error.response) {
      switch (error.response.status) {
        case 400:
          errorMsg({
            message: "请求参数不正确"
          });
          break
        case 401:
          errorMsg({
            message: "接口未授权"
          });
          break;
        case 404:
          errorMsg({
            message: "找不到服务器资源"
          });
          break;
        case 403:
          errorMsg({
            message: "非法IP"
          });
          break;
        case 999:
          errorMsg({
            message: "无效TOKEN"
          });
          router.push('/login')
          break;
        // 可以根据需要增加更多的错误状态码处理
        default:
          errorMsg(error.message)
      }
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.use(ElementUI);
Vue.use(util);
Vue.use(statusDesc);
Vue.use(taskStatusDesc);
// Vue.use(IPconfig);
Vue.use(date);
Vue.prototype.Driver = Driver;

Vue.prototype.$jsoneditor = jsoneditor;

// 过滤器
Vue.filter('dateFormat', (dataStr) => {
  console.log(dataStr);
  var time = new Date(dataStr);

  function timeAdd0(str) {
    if (str < 10) {
      str = '0' + str;
    }
    return str
  }

  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + ' ' + timeAdd0(h) + ':' + timeAdd0(mm) + ':' + timeAdd0(s);
});


// function inner(dataObject) {
//   Vue.prototype.baseUrl = dataObject.baseUrl;
//   Vue.prototype.moduleResourceUrl = dataObject.configurationURL;
//   Vue.prototype.moduleUrl = dataObject.moduleUrl;
//   Vue.prototype.containerTypes = dataObject.containerTypes;
//   Vue.prototype.grafanaUrl = dataObject.grafanaUrl;
//   Vue.prototype.detectApiUrl = dataObject.detectApiUrl;
//   Vue.prototype.deviceTypes = dataObject.deviceTypes;
//   Vue.prototype.npsApiUrl = dataObject.npsApiUrl;
//   Vue.prototype.logCollectServerUrl = dataObject.logCollectServerUrl;
//   Vue.prototype.baiduAk = dataObject.baiduAk;
//   Vue.prototype.qosUrl = dataObject.qosUrl;
//   Vue.prototype.qoscountServerUrl = dataObject.qoscountServerUrl;
//   Vue.prototype.apiUrl = dataObject.apiUrl;
//   Vue.prototype.alertUrl = dataObject.alertUrl;
//   Vue.prototype.baseUrl3 = dataObject.baseUrl3;
//   Vue.prototype.nginxUrl = dataObject.nginxUrl;
//   Vue.prototype.cdnUrl = dataObject.cdnUrl;
//
//   window.npsApiUrl = dataObject.npsApiUrl
// }
//
// function wan(dataObject) {
//   Vue.prototype.baseUrl = dataObject.baseUrlwan;
//   Vue.prototype.moduleResourceUrl = dataObject.configurationURLwan;
//   Vue.prototype.moduleUrl = dataObject.moduleUrlwan;
//   Vue.prototype.containerTypes = dataObject.containerTypes;
//   Vue.prototype.grafanaUrl = dataObject.grafanaUrlwan;
//   Vue.prototype.detectApiUrl = dataObject.detectApiUrlwan;
//   Vue.prototype.deviceTypes = dataObject.deviceTypes;
//   Vue.prototype.npsApiUrl = dataObject.npsApiUrlwan;
//   Vue.prototype.logCollectServerUrl = dataObject.logCollectServerUrlwan;
//   Vue.prototype.baiduAk = dataObject.baiduAk;
//   Vue.prototype.qosUrl = dataObject.qosUrlwan;
//   Vue.prototype.qoscountServerUrl = dataObject.qoscountServerUrlwan;
//   Vue.prototype.apiUrl = dataObject.apiUrlwan;
//   Vue.prototype.alertUrl = dataObject.alertUrlwan;
//   Vue.prototype.baseUrl3 = dataObject.baseUrl3wan;
//   Vue.prototype.nginxUrl = dataObject.nginxUrlwan;
//   Vue.prototype.cdnUrl = dataObject.cdnUrlwan;
//   window.npsApiUrl = dataObject.npsApiUrlwan;
// }
//
//
// async function detectNet(dataObject) {
//   let loading = Loading.service({
//     fullscreen: true,
//     text: "网络探测中..."
//   });
//   await axios.get(dataObject.baseUrl + 'imageCode',{timeout: 3000})
//     .then(({data: {code, msg, data}}) => {
//       inner(dataObject);
//       loading.close();
//       sessionStorage.setItem('netFlag', "1");
//     })
//     .catch(error => {
//       console.log(error);
//       loading.close();
//       wan(dataObject);
//       sessionStorage.setItem('netFlag', "2");
//     });
//
//
//   new Vue({
//     router,
//     store,
//     render: h => h(App)
//   }).$mount('#app')
// }

axios.get("/mmv/user.json").then(({data}) => {
  // let netFlag = sessionStorage.getItem('netFlag');
  // if (netFlag) {
  //   if (netFlag == "1") {
  //     inner(data);
  //   } else if (netFlag == "2") {
  //     wan(data);
  //   }
  //   new Vue({
  //     router,
  //     store,
  //     render: h => h(App)
  //   }).$mount('#app');
  // } else {
  //   detectNet(data)
  // }

  Vue.prototype.moduleResourceUrl = data.configurationURL;
  Vue.prototype.moduleUrl = data.moduleUrl;
  Vue.prototype.containerTypes = data.containerTypes;
  Vue.prototype.grafanaUrl = data.grafanaUrl;
  Vue.prototype.detectApiUrl = data.detectApiUrl;
  Vue.prototype.deviceTypes = data.deviceTypes;
  Vue.prototype.npsApiUrl = data.npsApiUrl;
  Vue.prototype.logCollectServerUrl = data.logCollectServerUrl;
  Vue.prototype.baiduAk = data.baiduAk;
  Vue.prototype.qosUrl = data.qosUrl;
  Vue.prototype.qoscountServerUrl = data.qoscountServerUrl;
  Vue.prototype.apiUrl = data.apiUrl;
  Vue.prototype.alertUrl = data.alertUrl;
  Vue.prototype.baseUrl3 = data.baseUrl3;
  Vue.prototype.nginxUrl = data.nginxUrl;
  Vue.prototype.cdnUrl = data.cdnUrl;
  window.npsApiUrl = data.npsApiUrl


  // Vue.prototype.users = data.users
  // Vue.prototype.baseUrl = data.baseUrl
  // Vue.prototype.moduleResourceUrl = data.configurationURL
  // Vue.prototype.moduleUrl = data.moduleUrl
  // Vue.prototype.containerTypes = data.containerTypes
  // Vue.prototype.grafanaUrl = data.grafanaUrl
  // Vue.prototype.detectApiUrl = data.detectApiUrl
  // Vue.prototype.deviceTypes = data.deviceTypes
  // Vue.prototype.npsApiUrl = data.npsApiUrl
  // Vue.prototype.logCollectServerUrl = data.logCollectServerUrl
  // Vue.prototype.ak = data.ak
  // Vue.prototype.qosUrl = data.qosUrl
  // Vue.prototype.apiUrl = data.apiUrl
  // Vue.prototype.baseUrl3 = data.baseUrl3
  // window.npsApiUrl = data.npsApiUrl

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
});


// console.log('**version**: 3.0.34');不需要了，版本号在首页显示了
